import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/registrationDataActions';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useRegistrationDataUIContext} from '../RegistrationDataUIContext';
import {InfoBox} from '../info-box/InfoBox';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";


export function RegistrationDataTable() {
  const intl = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const [infoData, setInfoData] = useState({});
  const columns = useMemo(() => [
    {
      accessor: 'fullName',
      Header: intl.formatMessage({
        id: 'registrationData-column-fullName', defaultMessage: 'Full name'
      })
    },
    {
      accessor: 'phone',
      Header: intl.formatMessage({
        id: 'registrationData-column-phone', defaultMessage: 'Phone'
      })
    },
    {
      accessor: 'cameFrom',
      Header: intl.formatMessage({
        id: 'registrationData-column-cameFrom',
        defaultMessage: 'How did you hear about us?'
      })
    },
    {
      accessor: 'practiceArea',
      Header: intl.formatMessage({
        id: 'registrationData-column-practiceArea',
        defaultMessage: 'Practice area'
      })
    },
    {
      accessor: 'lastCompletedStep',
      Header: intl.formatMessage({
        id: 'registrationData-column-lastCompletedStep',
        defaultMessage: 'Last completed step'
      })
    },
    {
      accessor: 'time',
      Header: intl.formatMessage({
        id: 'registrationData-column-time',
        defaultMessage: 'Time started and spent'
      })
    },
    {
      accessor: 'agentId',
      Header: intl.formatMessage({
        id: 'registrationData-column-agentId', defaultMessage: 'Agent Id'
      })
    },
    {
      accessor: 'tamalId',
      Header: intl.formatMessage({
        id: 'registrationData-column-tamalId', defaultMessage: 'Tamal Id'
      })
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        fullName: commonColumnFormatters.UserNameAndEmailColumnFormatter(item),
        phone: commonColumnFormatters.BoldColumnFormatter(item.profile.phone),
        cameFrom: [
          commonColumnFormatters.BoldColumnFormatter(item.cameFrom),
          commonColumnFormatters.LimitContentWidthBoldColumnFormatter(item.cameFromText)
        ],
        practiceArea: commonColumnFormatters.BoldColumnFormatter(item.practiceArea),
        lastCompletedStep: commonColumnFormatters.LastCompletedStepColumnFormatter(item.lastCompletedStep),
        time: commonColumnFormatters.TimeColumnFormatter(item),
        agentId: commonColumnFormatters.BoldColumnFormatter(item.agentId),
        tamalId: commonColumnFormatters.BoldColumnFormatter(item.tamalId),
      };
    })
  ], [tableRows]);
  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'registrationData',
    UIContext: useRegistrationDataUIContext(),
    getNewEntities: actions.getRegistrationData,
    getNextEntities: actions.getNextRegistrationData,
    onEntitiesChange: entities => {
      const filteredUsersList = entities.filter(item => entities.indexOf(item) % 2 === 0);
      const flattedUsersList = filteredUsersList.flat();
      setTableRows(flattedUsersList);
      setInfoData(entities[1]);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <>
      <InfoBox infoBoxData={infoData}/>
      <CommonGrid
        infiniteScrollProps={infiniteScrollProps}
        tableProps={useTable({columns, data})}
        customScrollContainerStyles={"custom-regData-scroll-container"}
        customTableStyles={'regData-table'}
      />
    </>
  );
}
